import { render, staticRenderFns } from "./AvoirsList.vue?vue&type=template&id=5583f3a8&"
import script from "./AvoirsList.vue?vue&type=script&lang=js&"
export * from "./AvoirsList.vue?vue&type=script&lang=js&"
import style0 from "./AvoirsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports